import { Navigate, Route, Routes } from 'react-router-dom'
import Whiteboard from '../../screens/Whiteboard/Whiteboard'
import RouteBuilder from '../../screens/RouteBuilder/RouteBuilder'
import UserManagement from '../../screens/UserManagement/UserManagement'
import Reports from '../../screens/Reports/Reports'
import MyFleet from '../../screens/MyFleet/Myfleet'
import DigitalReturns from '../../screens/DigitalReturns/DigitalReturns'
import VehicleDetails from '../../screens/MyFleet/components/VehicleDetails/VehicleDetails'
import { useFlags } from 'launchdarkly-react-client-sdk'
import CustomerManagement from '../../screens/CustomerManagement/CustomerManagement'
import NSSAChat from '../../screens/CometChat/NSSAChat'
import ReturnDetails from '../../screens/DigitalReturns/ReturnDetails/ReturnDetails'
import { StoreContext } from '../../utilities/contexts/StoreContext'
import { useContext, useEffect } from 'react'
import { FlagTypes } from '../../utilities/types/FlagTypes'

const NavBarMenu = () => {
  const { returnPilotStores } = useFlags<FlagTypes>()
  const { currentStore } = useContext(StoreContext)

  useEffect(() => {
    try{
      if(window?._detector){
        window._detector?.triggerCustomEvent("Store ID",currentStore);
      }
    } catch (e) {
    }
  }, [currentStore])

  return (
    <Routes>
      <Route index element={<Navigate to="/Whiteboard" />} />
      <Route path="/Whiteboard" element={<Whiteboard />} />
      <Route path="/CustomerMgmt" element={<CustomerManagement />} />
      <Route path="/RouteBuilder" element={<RouteBuilder />} />
      <Route path="/UserManagement" element={<UserManagement />} />
      <Route path="/Reports" element={<Reports />} />
      <Route path="/MyFleet" element={<MyFleet />} />
      {returnPilotStores?.includes(currentStore) && <Route path="/DigitalReturns" element={<DigitalReturns />} />}
      {returnPilotStores?.includes(currentStore) && <Route path="/ReturnDetails" element={<ReturnDetails />} />}
      <Route path="/VehicleDetails" element={<VehicleDetails />} />
      <Route path="/NSSAChat" element={<NSSAChat />} />
      <Route path="*" element={<p>Page Not Found</p>} />
    </Routes>
  )
}

export default NavBarMenu
